import React from 'react';
import { SubscriberTask } from 'types/electionService';
import { IconCheckmark, InfoButton } from '@insurancemenu/imenu-components-lib/dist/icons';
import { colors } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { SUBSCRIBER_TASK_TEST_IDS } from '../../constants';
import {
  ButtonStyled,
  TaskBodyStyled,
  TaskDescriptionKeyStyled,
  TaskDescriptionValueStyled,
  TaskStyled,
  TaskTitleStyled,
  TaskTitleWrapperStyled,
} from './styles';

interface Props {
  task: SubscriberTask;
  onRedirect: () => void;
}

const SubscriberTask: React.FC<Props> = observer(({ task, onRedirect }) => {
  const { entityId, name, description, active } = task;

  return (
    <TaskStyled key={entityId} data-test-id={`subscriber-task-${entityId}`}>
      <TaskTitleWrapperStyled>
        {active ? (
          <InfoButton height="4rem" width="4rem" color={colors.red[600]} />
        ) : (
          <IconCheckmark height="4rem" width="4rem" color={colors.neutral[600]} />
        )}
        <TaskTitleStyled data-test-id={SUBSCRIBER_TASK_TEST_IDS.TITLE}>{name}</TaskTitleStyled>
      </TaskTitleWrapperStyled>
      <TaskBodyStyled>
        <div>
          <TaskDescriptionKeyStyled>Description</TaskDescriptionKeyStyled>
          <TaskDescriptionValueStyled data-test-id={SUBSCRIBER_TASK_TEST_IDS.DESCRIPTION_VALUE}>
            {description}
          </TaskDescriptionValueStyled>
        </div>
        {active && (
          <ButtonStyled
            color="primary"
            size="large"
            width="18.4rem"
            onClick={onRedirect}
            data-test-id={SUBSCRIBER_TASK_TEST_IDS.CONTINUE_BUTTON}
          >
            Continue
          </ButtonStyled>
        )}
      </TaskBodyStyled>
    </TaskStyled>
  );
});

export default SubscriberTask;
